/**
 * Get GTM context
 */
 export function getGTMContext(container) {
    return (container?.dataset?.gtmContext) ? JSON.parse(container.dataset.gtmContext) : false
}
